import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getUnlistedUnits: {
        method: 'GET',
        url: `${BASE_PATH_API}/units/unlisted`
    },
    getListedUnits: {
        method: 'GET',
        url: `${BASE_PATH_API}/units/listed`
    },
    getListedUnitDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/units/:id/listed`
    },
    deListUnit: {
        method: 'PUT',
        url: `${BASE_PATH_API}/units/delist/:id`
    },
    getListing: {
        method: 'GET',
        url: `${BASE_PATH_API}/units/:id/listing`
    },
    updateListing: {
        method: 'PUT',
        url: `${BASE_PATH_API}/units/:id/listing`
    },
    getBedTypes: {
        method: 'GET',
        url: `${BASE_PATH_API}/listings/bedTypes`,
        isArray: true
    },
    getBathTypes: {
        method: 'GET',
        url: `${BASE_PATH_API}/listings/bathTypes`,
        isArray: true
    },
    getListingContacts: {
        method: 'GET',
        url: `${BASE_PATH_API}/listingcontacts`,
        isArray: true
    },
    listingSettingsInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/listingSettingsInfo`
    },
    getListingSyndicationSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/listingsyndicationsettings`,
        isArray: true
    },
    updateListingSyndicationSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/listingsyndicationsettings`,
        isArray: true
    },
    createListingContact: {
        method: 'POST',
        url: `${BASE_PATH_API}/ListingContacts`
    },
    updateListingContact: {
        method: 'PUT',
        url: `${BASE_PATH_API}/ListingContacts/:id`
    },
    deleteListingContact: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/ListingContacts/:id`
    },
    getListingInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/listings/:id`
    },
    getListingImagesZipFileName: {
        method: 'GET',
        url: `${BASE_PATH_API}/listings/:id/imagesZipFile`,
        isArray: true
    },
    getListingApplicationFeeSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/listings/:id/appFeeSummary`
    }
};

export function ListingsApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getListedUnitsExport = function getListedUnitsExport(params) {
        return `${BASE_PATH_API}/units/listed/export?${$httpParamSerializer(params)}`;
    };

    service.getUnlistedUnitsExport = function getUnlistedUnitsExport(params) {
        return `${BASE_PATH_API}/units/unlisted/export?${$httpParamSerializer(params)}`;
    };

    return service;
}
ListingsApi.$inject = [
    '$httpParamSerializer'
];
